import { computed, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { Activity } from '@/store/activity/activity.model';
import { ActivityAction, ActivityGetter } from '@/store/activity/activity.module';
import { AccountGetter } from '@/store/account/account.module';
import { Role } from '@/store/role/role.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';
import ActivityMessageComponent from '../activityMessage/ActivityMessage.vue';

export default defineComponent({
  name: 'ActivityOffcanvasComponent',
  components: {
    BaseOffcanvasComponent,
    ActivityMessageComponent,
  },
  props: {
    activityId: {
      type: Number,
    }
  },
  emits: [
    'edit',
  ],
  setup: (props, context) => {
    const store = useStore();
    const router = useRouter();
    const swal = useSweetAlert();
    const role = computed<Role | undefined>(() => store.getters[AccountGetter.SINGLE_ROLE]);
    const isOrs = computed(() => role.value?.name === 'เจ้าหน้าที่ ส.กกภ.');
    const activity = computed<Activity | undefined>(() => store.getters[ActivityGetter.BY_ID](props.activityId));
    const activityOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();
    const activityMessageModal = ref<InstanceType<typeof ActivityMessageComponent>>();
    const detail = ref(false);

    const show = () => {
      activityOffcanvas.value?.show();
    };

    const hide = () => {
      activityOffcanvas.value?.hide();
    };

    const detailClick = () => {
      detail.value = true;
      activityOffcanvas.value?.hide();
    };

    const editClick = () => {
      context.emit('edit', props.activityId);
    };

    const handleHidden = () => {
      if (detail.value) {
        detail.value = false;
        router.push(`/activity/${props.activityId}`);
      }
    };

    // delete item
    const deleteClick = () => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ActivityAction.DELETE, props.activityId)
              .then(() => hide());
          }
        });
    };

    const messageClick = () => {
      activityMessageModal.value?.show();
    };

    return {
      activity,
      activityOffcanvas,
      isOrs,
      activityMessageModal,
      show,
      hide,
      detailClick,
      editClick,
      deleteClick,
      handleHidden,
      messageClick,
    };
  }
});
